import React, { useEffect, useState } from "react";
import FaqItem from "./FaqItem";
import { API_BASE } from "../../Utils/constant";

const Faqs = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openFAQ, setOpenFAQ] = useState(null);

  useEffect(() => {
    const fetchFAQs = async () => {
      try {
        const response = await fetch(`${API_BASE}/faq`);
        if (!response.ok) {
          throw new Error("Failed to fetch FAQs");
        }
        const data = await response.json();


        setFaqs(data.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFAQs();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p style={{ color: "red" }}>Error: {error}</p>;
  }

  return (
    <div>
      <div className="profile-container">
        <h1 className="setting-header text-heading-h3 mb-3 mb-md-4">
          Frequently Asked Questions
        </h1>
        <div className="faqs-content-container">
          <div
            className="accordion faqs-accordion accordion-flush"
            id="setting-faqs-accordion"
          >
            {faqs.map((faq, index) => {
              const faqId = `faqs-accordion-${index + 1}`;
              return (
                <React.Fragment key={faqId}>
                  <FaqItem
                    id={faqId}
                    question={faq.question}
                    answer={faq.answer}
                    isOpen={openFAQ === faqId}
                    onToggle={(id) =>
                      setOpenFAQ((prevId) => (prevId === id ? null : id))
                    }
                  />
                  <hr className="accordion-horizontal-line" />
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
